import { useState, useEffect } from 'react'
import { dotPath, isNilOrEmpty } from 'ramdasauce'
import { useWindowSize } from 'react-use'
import Vimeo from '@u-wave/react-vimeo'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text, RoadcastRainbow, Animated, SanityButton } from 'components/atoms'

export const BackgroundVideoHero = ({ data }) => {
  const classes = useStyles()

  const [modal, setModal] = useState(false)
  const [bkgPlay, setBkgPlay] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const title = dotPath('title', data)
  const subtitle = dotPath('subtitle', data)
  const backgroundVideoId = dotPath('backgroundVideoId', data)
  const modalVideoId = dotPath('modalVideoId', data)
  const button = dotPath('button', data)

  const windowSize = useWindowSize()

  const handleModal = () => {
    setModal(!modal)
  }

  useEffect(() => {
    return setBkgPlay()
  }, [modal])

  const onLoaded = () => {
    setLoaded(true)
    modal &&
      setTimeout(function () {
        setBkgPlay(true)
      }, 1000)
  }

  const heightToggle =
    windowSize.height <
    windowSize.width * 0.6 * 0.5625 + windowSize.height * 0.4
      ? true
      : false
  const mobileFlip =
    windowSize.height < 500 && windowSize.width < 900 ? true : false

  const firstLineClasses = cn({
    [classes.firstLine]: true,
    [classes.shortButton]: heightToggle,
  })
  const closeModalClasses = cn({
    [classes.closeModal]: true,
    [classes.shortButton]: heightToggle,
  })

  const modalFlexClasses = cn({
    [classes.modalFlex]: true,
    [classes.modalFlexMobileFlipped]: mobileFlip,
    [classes.modalFlexTall]: heightToggle,
  })

  const videoClasses = cn({
    [classes.video]: true,
    [classes.loaded]: loaded,
  })

  const modalBlock = (
    <div className={classes.modal}>
      <div className={modalFlexClasses}>
        <iframe
          className={classes.modalVideo}
          title="background"
          src={`https://player.vimeo.com/video/${modalVideoId}?controls=1&byline=0&title=0&autopause=1`}
          frameBorder="0"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen={true}
          allow="autoplay"
        ></iframe>
        <button className={closeModalClasses} onClick={handleModal}>
          <div className={firstLineClasses} />
        </button>
      </div>
    </div>
  )

  return (
    <>
      <div className={classes.wrapper}>
        <Animated type="fade-in">
          <div className={classes.textBlock}>
            {!isNilOrEmpty(title) && (
              <Text size="header5" tag="h1" className={classes.title}>
                {title}
              </Text>
            )}
            {!isNilOrEmpty(subtitle) && (
              <Text tag="h2" size="subhead1" className={classes.subtitle}>
                {subtitle}
              </Text>
            )}
            {!isNilOrEmpty(button) && (
              <SanityButton data={button} className={classes.viewMore} />
            )}
          </div>
        </Animated>
        <div className={classes.videoWrapper}>
          <Vimeo
            video={backgroundVideoId}
            className={videoClasses}
            background={true}
            loop={true}
            onLoaded={onLoaded}
            paused={bkgPlay}
          />
          <div className={classes.triangle} />
          <button className={classes.openModal} onClick={handleModal}>
            <span className={classes.hidden}>Play</span>
          </button>
        </div>
        {modal && modalBlock}
      </div>
      <RoadcastRainbow flip />
    </>
  )
}
